import {Observable, throwError} from 'rxjs';
import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import { LocalStorageManager } from '../../manager/local-storage/local-storage.manager';
import { countryConfig } from 'src/country-config/country-config';
import { catchError, switchMap } from 'rxjs/operators';
import { TokensJwt } from '../../networking/models/customer/requests/token-jwt';
import { CustomerManager } from '../../manager/customer/customer/customer.manager';
import { SessionStorageManager } from '../../manager/session-storage/session-storage.manager';

@Injectable({
  providedIn: 'root',
})
export class JwtTokenInterceptor implements HttpInterceptor {

  private readonly HTTP_UNAUTHORIZED = 401;
  
  constructor(
    private customerManager: CustomerManager,
    private localStorageManager: LocalStorageManager,
    private sessionStorageManager: SessionStorageManager,
    @Inject(PLATFORM_ID) private platformId: any,
  ) { }

  set localCustomer(customer) {
    this.localStorageManager.set('customer', customer);
  } 
  
  get localCustomer() {
    return this.localStorageManager.get('customer');
  }
  
  get authorizationTokensJwt() { 
    const dataTemporal = this.sessionStorageManager.get('dataTemporal'); 
    if (dataTemporal?.tokensJwt) {
      return `Bearer ${dataTemporal.tokensJwt.accessToken}`; 
    }
    return `Bearer ${this.localCustomer?.tokensJwt?.accessToken}`;
  }


  intercept(initialRequest: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isBackendMultcountry = initialRequest.url.startsWith(countryConfig.backend.multiCountry);
    const isrefreshUrl = initialRequest.url.indexOf('/token/refresh') > -1;
    const allowUrl = isBackendMultcountry && !isrefreshUrl;
    const hasToken = this.localCustomer?.tokensJwt?.accessToken;
    if (allowUrl && hasToken){
      const newResquest = initialRequest.clone({
        setHeaders: {Authorization: this.authorizationTokensJwt}
      });
      return next.handle(newResquest).pipe(
        catchError(newResquestError => {
          const errorCode = newResquestError.error?.code ||  newResquestError.code;
          if(errorCode === this.HTTP_UNAUTHORIZED) { 
            return this.customerManager.refreshTokensJwt(this.localCustomer?.tokensJwt?.refreshToken).pipe(
              switchMap((newTokens: TokensJwt) => {
                this.localCustomer = {...this.localCustomer, tokensJwt: newTokens}; 
                this.customerManager.setLocalCustomer(this.localCustomer);
                const updateRequest = initialRequest.clone({
                  setHeaders: {Authorization: `Bearer ${newTokens.accessToken}`},
                });
                return next.handle(updateRequest);
              }),
              catchError(() => throwError({}))
            );
          }
          return this.responseWithError(newResquestError);
        }),
      );
    }
    return next.handle(initialRequest);
  }

  private responseWithError(errorResponse) {
    const error = errorResponse.error || errorResponse;
    const newError = new Error(error.message);
    if (error.data) { newError['data'] = error.data; }
    if (error.code) { newError['code'] = error.code; }
    return throwError(newError);
  }
}
